import { inject, injectable } from 'inversify'
import {
  AddExperienceUseCaseInput,
  AddExperienceUseCaseOutput,
  IAddExperienceUseCase,
  IAppErrorFactory,
  IExperienceFactory,
  IViewerService,
} from '@/types'
import symbols from '@/symbols'

@injectable()
export default class AddExperienceInteractor implements IAddExperienceUseCase {
  @inject(symbols.IViewerService) private viewerService: IViewerService

  @inject(symbols.IExperienceFactory) private experienceFactory: IExperienceFactory

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: AddExperienceUseCaseInput): Promise<AddExperienceUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      // uncontrolled input warning の対応
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      input.experience.endedAt = input.experience.endedAt || null
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      input.experience.startedAt = input.experience.startedAt || null

      const experience = await this.viewerService.addExperience({
        experience: input.experience,
      })
      output.experience = this.experienceFactory.create({
        base: experience,
      })
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
        messageForUI: '経歴情報の作成に失敗しました',
      })
    }

    return output
  }

  private getDefaultOutputData(): AddExperienceUseCaseOutput {
    return {
      experience: null,
      error: null,
    }
  }
}
